(function () {
  function initPositions(section) {
    var pills = section.querySelectorAll('.jbw-positions__pill');
    var rows = section.querySelectorAll('.jbw-positions__row');
    var countEl = section.querySelector('.jbw-positions__count');
    if (!pills.length) return;

    function update(filter) {
      var visible = 0;
      rows.forEach(function (row) {
        var loc = row.getAttribute('data-location') || '';
        var show = filter === 'all' || loc === filter;
        if (show) { row.removeAttribute('hidden'); visible++; }
        else { row.setAttribute('hidden', ''); }
      });
      pills.forEach(function (p) {
        var active = p.getAttribute('data-filter') === filter;
        p.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (countEl) {
        countEl.textContent = visible + ' role' + (visible !== 1 ? 's' : '');
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        update(pill.getAttribute('data-filter'));
      });
    });

    update('all');
  }

  function initAll() {
    document.querySelectorAll('.jbw-positions').forEach(initPositions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    if (section.querySelector('.jbw-positions')) {
      initPositions(section.querySelector('.jbw-positions'));
    }
  });
})();
